import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';

const Login = () => {
    const [login, setlogin] = useState("")
    const [password, setPassword] = useState("")
    const [loginError, setloginError] = useState("")
    const [passwordError, setPasswordError] = useState("")

    const navigate = useNavigate();

    const onButtonClick = () => {
        setloginError("")
        setPasswordError("")
        if ("" === login) {
            setloginError("Введите логин")
            return
        }
        if ("" === password) {
            setPasswordError("Введите пароль")
            return
        }
        logIn()
    }

    const logIn = () => {
        fetch("/api/auth", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
              },
            body: JSON.stringify({login, password})
        })
        .then(r => r.json())
        .then(r => {
            if ('success' === r.message) {
                localStorage.setItem("user", JSON.stringify({login, token: r.token}))
                if (login === "admin" || login === 'superadmin') {
                    navigate("/admin")
                } else {
                    navigate("/")
                }
            } else {
                setPasswordError("Неправильный логин или пароль")
            }
        })
    }

    return <div className={"mainContainer"}>
        <div className={"titleContainer"}>
            <div></div>
        </div>
        <br />

<form onSubmit={(e) => { e.preventDefault(); onButtonClick(); }}>
        <div className={"inputContainer"}>
            <input
                value={login}
                placeholder="Логин"
                onChange={ev => setlogin(ev.target.value.toLowerCase())}
                style={{textTransform: 'lowercase'}}
                className={"inputBox"} />
            <label className="errorLabel">{loginError}</label>
        </div>
        <br />
        <div className={"inputContainer"}>
            <input
                type="password"
                value={password}
                placeholder="Пароль"
                onChange={ev => setPassword(ev.target.value)}
                className={"inputBox"} />
            <label className="errorLabel">{passwordError}</label>
        </div>
        <br />


        <Button variant="primary" size="lg" type="submit">
          Войти
        </Button>
</form>

    </div>
}

export default Login
